// extracted by mini-css-extract-plugin
export default {"wrapper":"Service_wrapper__6jE3k","floating":"Service_floating__CSSpx","icon":"Service_icon__nLRaL"};